import { Controller } from "@hotwired/stimulus"

/**
 * Reports Hub tab indicator.
 *
 * The tab bar lives OUTSIDE the reports_tab_content Turbo Frame, so a
 * tab-link click only swaps the frame body — the active class on the
 * clicked link doesn't update without help. This controller toggles the
 * active state immediately on click so the indicator follows the user.
 *
 * Server-side render still authoritatively sets the active tab on full
 * page loads (bookmarked tab URLs) — this controller only handles the
 * client-side mid-session toggle.
 */
export default class extends Controller {
  static targets = ["link"]

  setActive(event) {
    const clicked = event.currentTarget
    this.linkTargets.forEach(link => {
      const isActive = link === clicked
      link.classList.toggle("active", isActive)
      link.setAttribute("aria-selected", isActive ? "true" : "false")
    })
  }
}
